import ProfileIcon from 'assets/images/auth/profile.svg'
import { Field, Form, Formik } from 'formik'
import useGetProfile from './hooks/useGetProfile'
import DotsLoading from 'components/loadings/dotsLoading'
import CustomButton from 'components/customButtons/primary'
import { Schema, initialValues } from './utilities'
import useSetAuthProfile from './hooks/useSetAuthProfile'
import { useEffect, useState } from 'react'
import ProfileModal from 'components/modals/authProfile'
import { useNavigate } from 'react-router-dom'
import posthog from 'posthog-js'
export default function ProfileLogin() {
    const [showModal, setShowModal] = useState<boolean>(false)
    const { profileData, isLoading } = useGetProfile()
    const navigate = useNavigate()
    useEffect(() => {
        if (profileData) {
            posthog.identify(profileData?.phone_number, {
                user_id: profileData?.id,
                name: profileData?.first_name + ' ' + profileData?.last_name,
                email: profileData?.email,
                phone_number: profileData?.phone_number,
            })
            localStorage.setItem('profile', JSON.stringify(profileData))
        } else {
            console.log('profile data is unavilable')
        }
    }, [profileData])
    const { mutate } = useSetAuthProfile(setShowModal)
    return (
        <div className=" w-full h-screen bg-main-bg ">
            {isLoading ? (
                <div className=" w-full h-screen items-center">
                    <DotsLoading />
                </div>
            ) : (
                <Formik
                    enableReinitialize
                    initialValues={initialValues(profileData)}
                    validationSchema={Schema}
                    onSubmit={async (values) => {
                        if (
                            profileData &&
                            !profileData?.first_name?.length &&
                            !profileData?.last_name?.length
                        ) {
                            const payload: IAuthprofilePayload = {
                                ...(profileData &&
                                    profileData.first_name !==
                                        values.first_name && {
                                        first_name: values.first_name,
                                    }),
                                ...(profileData &&
                                    values.last_name !==
                                        profileData?.last_name && {
                                        last_name: values.last_name,
                                    }),
                                ...(profileData &&
                                    profileData.email !== values.email && {
                                        email: values.email,
                                    }),
                            }
                            mutate(payload)
                        } else {
                            navigate('/funds')
                        }
                    }}
                >
                    {({ values, touched, errors }) => (
                        <Form
                            className="h-screen flex flex-col"
                            id="authProfile"
                        >
                            <p className=" text-center text-current my-6 ">
                                حساب کاربری
                            </p>
                            <div className=" mx-4  mt-24 text-center grow">
                                <div className=" bg-white shadow-[0px_2px_3px_-1px_rgba(0,0,0,0.1),0px_1px_0px_0px_rgba(25,28,33,0.02),0px_0px_0px_1px_rgba(25,28,33,0.08)] rounded-md ">
                                    <div className="relative w-full flex justify-center ">
                                        <img
                                            src={ProfileIcon}
                                            className=" mx-auto absolute -mt-14 pl-5 "
                                            alt="profile-icon"
                                        />
                                    </div>
                                    <p className=" text-text-gray text-sm my-4 pt-6">
                                        تلفن همراه
                                    </p>
                                    <p className=" mb-4">
                                        {profileData &&
                                            `0${profileData?.phone_number?.slice(
                                                3
                                            )}`}
                                    </p>
                                    <div>
                                        {profileData &&
                                        profileData?.first_name?.length ? (
                                            <p className=" w-full outline-0 text-center border-t border-b border-dashed border-gray-1 py-3">
                                                {profileData.first_name}
                                            </p>
                                        ) : (
                                            <>
                                                <Field
                                                    type="text"
                                                    className=" w-full outline-0 text-center border-t border-b border-dashed border-gray-1 py-3"
                                                    placeholder="نام (الزامی)"
                                                    name="first_name"
                                                />
                                                {touched.first_name &&
                                                    errors.first_name && (
                                                        <p className=" text-xs text-red-1">
                                                            {errors.first_name}
                                                        </p>
                                                    )}
                                            </>
                                        )}
                                        {profileData &&
                                        profileData?.last_name?.length ? (
                                            <p className="w-full outline-0 text-center border-b border-dashed border-gray-1 py-3">
                                                {profileData.last_name}
                                            </p>
                                        ) : (
                                            <>
                                                <Field
                                                    type="text"
                                                    className=" w-full outline-0 text-center border-b border-dashed border-gray-1 py-3"
                                                    placeholder="نام خانوادگی (الزامی)"
                                                    name="last_name"
                                                />
                                                {touched.last_name &&
                                                    errors.last_name && (
                                                        <p className=" text-xs text-red-1">
                                                            {errors.last_name}
                                                        </p>
                                                    )}
                                            </>
                                        )}
                                        {profileData &&
                                        profileData?.email &&
                                        profileData?.email.length > 0 ? (
                                            <p className="w-full outline-0 text-center border-b border-dashed border-gray-1 py-3">
                                                {profileData.email}
                                            </p>
                                        ) : (
                                            <>
                                                <Field
                                                    type="text"
                                                    className=" w-full outline-0 text-center border-b border-dashed border-gray-1 py-3"
                                                    placeholder="پست الکترونیک (اختیاری)"
                                                    name="email"
                                                />
                                                {touched.email &&
                                                    errors.email && (
                                                        <p className=" text-xs text-red-1">
                                                            {errors.email}
                                                        </p>
                                                    )}
                                            </>
                                        )}
                                        <input
                                            type="text"
                                            className=" w-full outline-0 text-center py-3"
                                            placeholder="کد معرف (اختیاری)"
                                            disabled
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className=" mb-4 mx-6">
                                <CustomButton
                                    label="ورود"
                                    type="submit"
                                    setShowModal={() => {
                                        if (
                                            profileData &&
                                            !profileData?.first_name
                                                ?.length &&
                                            !profileData?.last_name?.length
                                        ) {
                                            setShowModal(true)
                                        }
                                    }}
                                />
                            </div>
                            <ProfileModal
                                show={showModal}
                                onHide={() => setShowModal(false)}
                                type="submit"
                            />
                        </Form>
                    )}
                </Formik>
            )}
        </div>
    )
}
